import React, { useState } from 'react';
import { FaEyeSlash ,FaEye} from "react-icons/fa";

const Input = ({
  value,
  onChange,
  placeholder,
  type = 'text',
  name,
  validate,
  errorMessage,
  className = '',
}) => {
  const [touched, setTouched] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleBlur = () => {
    setTouched(true);
    if (validate) {
      const validationError = validate(value);
      setError(validationError);
    }
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    if (validate) {
      const validationError = validate(newValue);
      setError(validationError);
    }
    onChange(e);
  };
  const isPassword = type === "password";

  return (
    <div className={`${className}`}>
      <div className="relative">
        <input
          type={isPassword && showPassword ? "text" : type}
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={handleChange}
          onBlur={handleBlur}
          className="drop-shadow-lg rounded-lg p-2 outline-none focus:ring-0 focus:border-orange-primary w-full pr-10"
          autoComplete={name === "password" ? "current-password" : name === "email" ? "email" : "off"}
          style={{ boxSizing: 'border-box' }}
        />
        {isPassword && (
          <span
            className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-orange-primary"
            onClick={() => setShowPassword((prev) => !prev)}
            tabIndex={0}
            aria-label={showPassword ? "Hide password" : "Show password"}
            style={{ zIndex: 10 }}
          >
            {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
          </span>
        )}
      </div>
      {touched && error && (
        <p className="text-red-500 text-xs mt-1 ml-1">
          {errorMessage || error}
        </p>
      )}
    </div>
  );
};

export default Input;
